import { Routes } from '@angular/router';
import { AuthGuard } from '@nova-portal/frontend-lib/firebase';
import { LoginPage } from '@nova-portal/frontend-lib/pages';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'customers'
	},
	{
		path: 'customers',
		canMatch: [AuthGuard],
		loadComponent: () => import('./customer/customer-list/customers.page').then(m => m.CustomersPage)
	},
	{
		path: 'error',
		loadChildren: () => import('@nova-portal/frontend-lib/pages').then(m => m.errorRoutes)
	},
	{
		path: 'login',
		component: LoginPage
	},
	{
		path: '__/auth/',
		component: LoginPage
	},
	{
		path: '**',
		redirectTo: '/error/notfound'
	}
];
